var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { attrs: { align: "left" } }, [
    _c(
      "div",
      { staticClass: "top w-100" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { staticClass: "mb-3 mb-md-0", attrs: { cols: "12", md: "6" } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      {
                        staticClass: "mb-3 mb-md-0",
                        attrs: { cols: "6", md: "6" }
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "d-inline-block text-white font-weight-bold mb-3",
                            attrs: { href: _vm.mv_url + "/" }
                          },
                          [_vm._v("Home")]
                        ),
                        _vm._v(" "),
                        _c("ul", { staticClass: "list-unstyled" }, [
                          _c("li", { staticClass: "mb-2" }, [
                            _c(
                              "a",
                              {
                                staticClass: "text-white",
                                attrs: { href: _vm.mv_url + "/about-us/" }
                              },
                              [_vm._v("About Us")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "mb-2" }, [
                            _c(
                              "a",
                              {
                                staticClass: "text-white",
                                attrs: { href: _vm.mv_url + "/musicians/" }
                              },
                              [_vm._v("Musicians")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "mb-2" }, [
                            _c(
                              "a",
                              {
                                staticClass: "text-white",
                                attrs: { href: _vm.mv_url_wp + "/blog/" }
                              },
                              [_vm._v("Blog")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "mb-2" }, [
                            _c(
                              "a",
                              {
                                staticClass: "text-white",
                                attrs: { href: "/#/donation-page" }
                              },
                              [_vm._v("Mission Projects")]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "6", md: "6" } }, [
                      _c(
                        "span",
                        { staticClass: "d-inline-block font-weight-bold mb-3" },
                        [_vm._v("Contact")]
                      ),
                      _vm._v(" "),
                      _c("ul", { staticClass: "list-unstyled" }, [
                        _c("li", { staticClass: "mb-2" }, [
                          _c(
                            "a",
                            {
                              staticClass: "text-white",
                              attrs: { href: "mailto:info@musicverse.org" }
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "mr-3 footer-icon d-none d-sm-inline-block",
                                attrs: {
                                  src: require("@/assets/mail-footer-icon.png")
                                }
                              }),
                              _vm._v("info@musicverse.org")
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "mb-2" }, [
                          _c(
                            "a",
                            {
                              staticClass: "text-white",
                              attrs: {
                                href: "https://www.facebook.com/musicverse.org"
                              }
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "mr-3 footer-icon  d-none d-sm-inline-block",
                                attrs: {
                                  src: require("@/assets/fb-footer-icon.png")
                                }
                              }),
                              _vm._v("Facebook")
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "mb-2" }, [
                          _c(
                            "a",
                            {
                              staticClass: "text-white",
                              attrs: {
                                href:
                                  "https://www.instagram.com/musicverseinternational/?hl=en"
                              }
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "mr-3 footer-icon  d-none d-sm-inline-block",
                                attrs: {
                                  src: require("@/assets/ig-footer-icon.png")
                                }
                              }),
                              _vm._v("Instagram")
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "mb-2" }, [
                          _c(
                            "a",
                            {
                              staticClass: "text-white",
                              attrs: {
                                href: "https://twitter.com/MusicVerseIntl"
                              }
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "mr-3 footer-icon  d-none d-sm-inline-block",
                                attrs: {
                                  src: require("@/assets/twitter-footer-icon.png")
                                }
                              }),
                              _vm._v("Twitter")
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "mb-2" }, [
                          _c(
                            "a",
                            {
                              staticClass: "text-white",
                              attrs: {
                                href:
                                  "https://www.youtube.com/channel/UCjRCshDsxtam7Wh9SIKLuHA"
                              }
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "mr-3 footer-icon  d-none d-sm-inline-block",
                                attrs: {
                                  src: require("@/assets/yt-footer-icon.png")
                                }
                              }),
                              _vm._v("Youtube")
                            ]
                          )
                        ])
                      ])
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-col",
              { attrs: { cols: "12", md: "6", align: "right" } },
              [
                _c(
                  "b-row",
                  {
                    staticClass:
                      "justify-content-center flex-column flex-sm-row justify-content-xl-end align-items-center"
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "mt-3 mt-sm-0 mr-0 mr-sm-3 footer-logo",
                        attrs: {
                          href: "https://musicverse.onelink.me/vYmO/mainwebsite"
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "footer-logo",
                          attrs: {
                            src: require("@/assets/applestore-logo.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "mt-3 mt-sm-0 mr-0 mr-sm-3 footer-logo",
                        attrs: {
                          href: "https://musicverse.onelink.me/vYmO/mainwebsite"
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "footer-logo",
                          attrs: {
                            src: require("@/assets/googleplay-logo.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "mt-3 mt-xl-0 footer-logo",
                        attrs: {
                          href: "https://musicverse.onelink.me/vYmO/mainwebsite"
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "footer-logo radius",
                          attrs: { src: require("@/assets/huawei-logo.png") }
                        })
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copyright w-100" }, [
      _c("span", [
        _vm._v("MusicVerse © 2021 All Rights Reserved Legal Info, "),
        _c(
          "a",
          {
            staticStyle: { color: "#ffffff" },
            attrs: { href: "https://musicverse.org/terms-and-conditions/" }
          },
          [_vm._v("Terms of Use")]
        ),
        _vm._v(", "),
        _c(
          "a",
          {
            staticStyle: { color: "#ffffff" },
            attrs: { href: "https://musicverse.org/privacy-policy/" }
          },
          [_vm._v("Privacy Policy")]
        ),
        _vm._v(". ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e976408", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e976408","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterLanding.vue
// module id = null
// module chunks = 